import {HttpClient, HttpHeaders, HttpParamsOptions, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject, observable} from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginDto } from '../../models/auth/login-dto.model';
import { BaseService } from '../base.service';
import {WhStockModel} from "../../models/loads/wh-stock.model";
import {TruckLoadDetailModel} from "../../models/loads/truck-load-detail.model";
import {WhForwardingModel} from "../../models/loads/wh-forwarding.model";
import {SimpleEntity} from "../../models/simple-entity.model";
import {StockInventoryModel} from "../../models/loads/stock-inventory.model";
import {WhStockRequestedModel} from "../../models/loads/wh-stock-requested.model";
import { WhTransferOrderModel } from 'src/app/models/loads/wh-transfer-order.model';

@Injectable()
export class LoadsService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'loads',
            httpClient);
    }

    searchdomesticDistributionOrderPack(createDateStart?: string, createDateEnd?: string, operationDateStart?: string, operationDateEnd?: string, deliveryDateStart?: string, deliveryDateEnd?: string, distributionReferenceNo?: string, status?: string): Observable<any> {

        const uri  = new URL(environment.baseUrl + '/loads/searchdomesticDistributionOrderPack').updateQueryParam({
            createDateStart, createDateEnd, operationDateStart, operationDateEnd, deliveryDateStart, deliveryDateEnd, distributionReferenceNo, status
        });

        return this.httpClient.get<WhStockModel[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    searchwhProduct(warehouseId?:number, productType?:string, categoryId?: number, productName?: string, productCode?: string, productBrand?: string, isLimit?: boolean, page?: number): Observable<WhStockModel[]> {
        console.log(page,'page');
        if (!page) page = 0;
        let uri  = new URL(environment.baseUrl + '/loads/searchwhProduct')
          .updateQueryParam({warehouseId, productType, categoryId, productName, productCode, productBrand, isLimit, page: page ? page : '0'})

        return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    searchwhProductWithResponse(warehouseId?:number, productType?:string, categoryId?: number, productName?: string, productCode?: string, productBrand?: string,whProjectId?: number, isLimit?: boolean, page?: number): Observable<HttpResponse<any>> {
        console.log(page,'page',whProjectId);
        if (!page) page = 0;
        let uri  = new URL(environment.baseUrl + '/loads/searchwhProduct')
            .updateQueryParam({warehouseId, productType, categoryId, productName, productCode, productBrand,whProjectId, isLimit, page: page ? page : '0'})

        return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders(), observe: "response" })
    }

    getDomesticDistrubitonOrderPackDetail(id): Observable<TruckLoadDetailModel> {
        let uri = new URL(environment.baseUrl + '/loads/getDomesticDistrubitonOrderPackDetail').updateQueryParam({
            id
        })
        return this.httpClient.get<TruckLoadDetailModel>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }


    getReport(reportId, entityId): Observable<any> {
        let uri = new URL(environment.baseUrl + '/loads/getReport').updateQueryParam({
            reportId, entityId
        })
        // @ts-ignore
        return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders(), responseType: 'blob', observe: 'body' })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }

    createOrUpdateWhForwarding(whForwardingModel: WhForwardingModel): Observable<WhForwardingModel[]> {
        let uri = new URL(environment.baseUrl + `/loads/${whForwardingModel.id ? 'updateWhForwarding': 'createWhForwarding'}`);
        // @ts-ignore
        return this.httpClient.post<WhForwardingModel[]>(uri.toString(),whForwardingModel, { withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }

    setStatusWhForwarding(whForwardingModel: WhForwardingModel): Observable<WhForwardingModel[]> {
        let uri = new URL(environment.baseUrl + `/loads/updateWhForwardingStatus`);
        // @ts-ignore
        return this.httpClient.post<WhForwardingModel[]>(uri.toString(),whForwardingModel, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

   deleteWhForwarding(whForwardingId: number): Observable<Boolean> {
        let uri = new URL(environment.baseUrl + `/loads/deleteWhForwarding/${whForwardingId}`);
        // @ts-ignore
        return this.httpClient.delete<Boolean>(uri.toString(),{ withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }


    getWhForwardings(status?: string): Observable<SimpleEntity[]> {
        let uri = new URL(environment.baseUrl + '/loads/getWhForwardings').updateQueryParam({status})
        return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }
    countWhForwardings(status?: string): Observable<number> {
        let uri = new URL(environment.baseUrl + '/loads/countWhForwardings').updateQueryParam({status})
        return this.httpClient.get<number>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }

    getWhForwardingsByAllStatus(createDateStart?: string, createDateEnd?: string,referenceNo? :string,code?:string): Observable<SimpleEntity[]> {
        let uri = new URL(environment.baseUrl + '/loads/getWhForwardingsByAllStatus').updateQueryParam({
            createDateStart, createDateEnd,referenceNo,code});
        return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    getWhForwarding(whForwardingId: number): Observable<WhForwardingModel> {
        let uri = new URL(environment.baseUrl + '/loads/getWhForwarding').updateQueryParam({whForwardingId});
        return this.httpClient.get<WhForwardingModel>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
          .pipe(
            tap(),
            catchError(this.handleError)
          )
    }

  getStockInventory(startDate?: string, endDate?: string): Observable<StockInventoryModel[]> {
    const uri  = new URL(environment.baseUrl + '/loads/getWhStockInventory').updateQueryParam({startDate, endDate});
    return this.httpClient.get<StockInventoryModel[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }

  getWhStockRequested(createDateStart?: string, createDateEnd?: string): Observable<WhStockRequestedModel[]> {
    const uri  = new URL(environment.baseUrl + '/loads/getWhStockRequested').updateQueryParam({createDateStart, createDateEnd});
    return this.httpClient.get<WhStockRequestedModel[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }
    getWhProjects(): Observable<SimpleEntity[]> {
    const uri  = new URL(environment.baseUrl + '/loads/getWhProjects');
    return this.httpClient.get<SimpleEntity[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
  }

  createWhTransfer(whTransferOrder: WhTransferOrderModel): Observable<WhTransferOrderModel> {
    let uri = new URL(environment.baseUrl + `/loads/createWhTransfer`);
    // @ts-ignore
    return this.httpClient.post<WhTransferOrderModel>(uri.toString(),whTransferOrder, { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
}
}
